import React from 'react';
import MyIcon from '../my-icon';

import style from './style.less';

export function PageHelperLink({ to, children }) {
  return (
    <a href={to} target="_blank">
      <MyIcon type="ecoboost-iconfontread" className={style.icon} />
      {children}
    </a>
  );
}
